import React from "react";
import Select from "react-select";
import { useField, useFormikContext } from "formik";

const FormikDropdown = ({
    label,
    name,
    options,
    placeholder = "Select",
    required = false,
    needSearch = false,
    disabled = false,
    ...props
}) => {
    const { setFieldValue } = useFormikContext();
    const [field, meta] = useField(name);

    const handleChange = (selectedOption) => {
        setFieldValue(name, selectedOption ? selectedOption.value : "");
        if (props.onChange) {
            props.onChange(selectedOption); // Call the parent onChange if provided
        }
    };

    return (
        <div className="form-control flex flex-col gap-2 p-2 text-xs">
            {/* Label */}
            {label && (
                <label
                    htmlFor={name}
                    className="font-medium flex items-center text-xs"
                >
                    {label}
                    {required && <span className="text-red-600 font-bold ml-1 text-xs">*</span>}
                </label>
            )}
            <Select
                options={options}
                value={options.find((option) => option.value === field.value) || null}
                onChange={handleChange}
                classNamePrefix="react-select"
                className="text-xs"
                placeholder={placeholder}
                isDisabled={disabled}
                isSearchable={needSearch}
            />

            {/* Error Message */}
            {meta.touched && meta.error && (
                <p
                    className="mt-2 text-xs text-red-500"
                    id={`${name}-error`}
                >
                    {meta.error}
                </p>
            )}
        </div>
    );
};

export default FormikDropdown;
